export default __webpack_public_path__ + "static/飞书20210924-194610-en-9f8538431e6ba3209059c7ddf9643f29.jpg";